import Graph from './graph'
import React from 'react'
import FixedGraph from '../patient/forms/devlinegraph'

const LineGraph = (props) => {
  return props.fixed ? (
    <FixedGraph
      width={props.width}
      height={props.height}
      identifier={'aq' + props.data._id.replace(' ', '_')}
      data={props.data}
      isrotate={props.isrotate}
    />
  ) : (
    <Graph
      width={props.width}
      height={props.height}
      identifier={'a' + props.data._id.replace(' ', '_')}
      data={props.data}
      isrotate={props.isrotate}
    />
  )
}

export default LineGraph
